import React from "react";
import UserList from "../Table/UserList";

const ValetList = () => {
  return <UserList userRole={4} userType={"valet"} />;
};

export default ValetList;
